import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import SchemaOrg from '../../components/feature/SchemaOrg';

export default function CaseDetail3Page() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const processSteps = [
    {
      title: '電話諮詢估價',
      time: '搬家前 3 天',
      description: '透過電話了解物品數量和搬運需求，提供精準報價',
      image: 'https://public.readdy.ai/ai/img_res/2fd017773782f111e5599291becc5943.jpg'
    },
    {
      title: '到府打包服務',
      time: '搬家當天上午',
      description: '專業人員到府協助打包，衣物、書籍、生活用品分類裝箱',
      image: 'https://readdy.ai/api/search-image?query=Professional%20movers%20packing%20clothes%20and%20personal%20items%20in%20small%20Taiwan%20studio%20apartment%2C%20organized%20boxes%20with%20labels%2C%20efficient%20packing%20service%20for%20young%20tenant%2C%20compact%20living%20space%20organization&width=800&height=600&seq=case-detail-3-step2&orientation=landscape'
    },
    {
      title: '家具保護包裝',
      time: '搬家當天',
      description: '使用保護墊和氣泡紙包裝家具，防止搬運過程中刮傷',
      image: 'https://readdy.ai/api/search-image?query=Movers%20wrapping%20small%20furniture%20with%20protective%20materials%20in%20Taiwan%20studio%20apartment%2C%20bubble%20wrap%20and%20moving%20blankets%20protecting%20desk%20and%20shelves%2C%20careful%20furniture%20protection%20process&width=800&height=600&seq=case-detail-3-step3&orientation=landscape'
    },
    {
      title: '快速搬運裝車',
      time: '搬家當天',
      description: '2位專業師傅快速搬運，小型搬運車高效裝載',
      image: 'https://readdy.ai/api/search-image?query=Two%20professional%20movers%20loading%20boxes%20and%20small%20furniture%20into%20compact%20moving%20van%20in%20Taiwan%20residential%20area%2C%20efficient%20loading%20process%20for%20studio%20apartment%20move%2C%20organized%20cargo%20arrangement&width=800&height=600&seq=case-detail-3-step4&orientation=landscape'
    },
    {
      title: '新居物品定位',
      time: '搬家當天下午',
      description: '按照客戶需求擺放家具和物品，協助基本整理',
      image: 'https://readdy.ai/api/search-image?query=Movers%20placing%20furniture%20in%20new%20Taiwan%20studio%20apartment%20according%20to%20tenant%20preference%2C%20organized%20room%20setup%20with%20bed%20desk%20and%20shelves%2C%20cozy%20compact%20living%20space%20arrangement&width=800&height=600&seq=case-detail-3-step5&orientation=landscape'
    },
    {
      title: '清潔驗收完成',
      time: '搬家當天傍晚',
      description: '清理包裝材料，確認物品完整，客戶滿意簽收',
      image: 'https://readdy.ai/api/search-image?query=Happy%20young%20tenant%20inspecting%20completed%20studio%20apartment%20move%20in%20Taiwan%2C%20clean%20organized%20small%20living%20space%2C%20satisfied%20customer%20with%20moving%20team%2C%20successful%20relocation%20completion&width=800&height=600&seq=case-detail-3-step6&orientation=landscape'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <SchemaOrg 
        type="review" 
        data={{
          reviewRating: 5,
          reviewAuthor: '黃同學',
          reviewDate: '2024-02-15',
          reviewText: '學生預算有限，建鈞搬家的價格很合理。師傅們很認真負責，服務態度親切，讓我第一次搬家感到很安心。'
        }}
      />

      <Header />

      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-br from-cyan-600 to-teal-600 overflow-hidden">
        <div className="absolute inset-0 bg-pattern opacity-10"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center gap-3 text-cyan-100 mb-6">
            <Link to="/cases" className="hover:text-white transition-colors flex items-center gap-2">
              <i className="ri-arrow-left-line"></i>
              <span>返回案例列表</span>
            </Link>
            <span>/</span>
            <span className="text-white">案例詳情</span>
          </div>

          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm text-white px-4 py-2 rounded-full text-sm font-semibold mb-6">
                <i className="ri-home-4-line"></i>
                <span>套房搬遷</span>
              </div>

              <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
                新北新莊套房搬遷
              </h1>

              <p className="text-xl text-cyan-100 mb-8 leading-relaxed">
                黃同學從新莊舊套房搬到學校附近的新租屋處，8坪小套房包含床組、書桌、衣櫃和生活用品。我們提供經濟實惠的套房搬遷方案，3小時內完成搬遷。
              </p>

              <div className="grid grid-cols-2 gap-4">
                <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-4">
                  <div className="text-cyan-100 text-sm mb-1">客戶姓名</div>
                  <div className="text-white text-lg font-semibold">黃同學</div>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-4">
                  <div className="text-cyan-100 text-sm mb-1">搬遷地點</div>
                  <div className="text-white text-lg font-semibold">新北市新莊區</div>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-4">
                  <div className="text-cyan-100 text-sm mb-1">套房坪數</div>
                  <div className="text-white text-lg font-semibold">8 坪</div>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-4">
                  <div className="text-cyan-100 text-sm mb-1">搬遷費用</div>
                  <div className="text-white text-lg font-semibold">$3,500</div>
                </div>
              </div>
            </div>

            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-r from-cyan-400 to-teal-400 rounded-3xl blur-2xl opacity-30"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Cozy%20modern%20studio%20apartment%20interior%20in%20New%20Taipei%20Taiwan%20with%20organized%20furniture%20including%20bed%20desk%20and%20wardrobe%2C%20compact%20living%20space%20for%20young%20student%2C%20bright%20natural%20lighting%2C%20clean%20minimalist%20design&width=800&height=600&seq=case-detail-3-hero&orientation=landscape"
                alt="新北新莊套房搬遷"
                className="relative rounded-3xl shadow-2xl w-full h-96 object-cover object-top"
              />
            </div>
          </div>
        </div>
      </section>

      {/* 客戶評價 */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-gradient-to-br from-cyan-50 to-teal-50 rounded-3xl p-8 md:p-12 shadow-lg">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-20 h-20 bg-gradient-to-br from-cyan-500 to-teal-500 rounded-full flex items-center justify-center text-white text-3xl font-bold shadow-lg">
                黃
              </div>
              <div>
                <div className="text-2xl font-bold text-gray-900">黃同學</div>
                <div className="text-gray-600">大學生</div>
                <div className="flex items-center gap-2 mt-2">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-2xl"></i>
                  ))}
                  <span className="text-gray-600 font-semibold ml-2">5.0 分</span>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-md">
              <div className="flex items-start gap-3">
                <i className="ri-double-quotes-l text-cyan-600 text-4xl flex-shrink-0"></i>
                <div className="flex-1">
                  <p className="text-gray-700 text-lg leading-relaxed mb-4">
                    學生預算有限，建鈞搬家的價格很合理。雖然東西不多，但師傅們還是很認真負責，幫我把所有東西都搬好了。
                  </p>
                  <p className="text-gray-700 text-lg leading-relaxed">
                    服務態度很親切，讓我這個第一次自己搬家的學生感到很安心。師傅還教我怎麼整理新房間比較方便，真的很貼心！下次搬家還會找他們！
                  </p>
                </div>
                <i className="ri-double-quotes-r text-cyan-600 text-4xl flex-shrink-0"></i>
              </div>
            </div>

            <div className="mt-6 flex items-center justify-between text-sm text-gray-600">
              <div className="flex items-center gap-2">
                <i className="ri-calendar-line"></i>
                <span>2024年2月15日</span>
              </div>
              <div className="bg-cyan-100 text-cyan-800 px-4 py-2 rounded-full font-semibold">
                學生優惠
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 搬家過程 */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">完整搬家流程</h2>
            <p className="text-xl text-gray-600">小套房搬遷，快速又經濟</p>
          </div>

          <div className="space-y-16">
            {processSteps.map((step, index) => (
              <div key={index} className={`grid lg:grid-cols-2 gap-8 items-center ${index % 2 === 1 ? 'lg:flex-row-reverse' : ''}`}>
                <div className={index % 2 === 1 ? 'lg:order-2' : ''}>
                  <div className="relative">
                    <div className="absolute -top-6 -left-6 w-16 h-16 bg-cyan-600 rounded-full flex items-center justify-center text-white text-2xl font-bold shadow-lg z-10">
                      {index + 1}
                    </div>
                    <img
                      src={step.image}
                      alt={step.title}
                      className="rounded-3xl shadow-2xl w-full h-96 object-cover object-top"
                    />
                  </div>
                </div>

                <div className={index % 2 === 1 ? 'lg:order-1' : ''}>
                  <div className="inline-flex items-center gap-2 bg-cyan-100 text-cyan-800 px-4 py-2 rounded-full text-sm font-semibold mb-4">
                    <i className="ri-time-line"></i>
                    <span>{step.time}</span>
                  </div>

                  <h3 className="text-3xl font-bold text-gray-900 mb-4">{step.title}</h3>
                  <p className="text-lg text-gray-700 leading-relaxed">{step.description}</p>

                  <div className="mt-6 bg-gradient-to-br from-cyan-50 to-teal-50 rounded-2xl p-6">
                    <div className="flex items-start gap-3">
                      <i className="ri-checkbox-circle-fill text-cyan-600 text-2xl flex-shrink-0 mt-1"></i>
                      <div>
                        <div className="font-semibold text-gray-900 mb-2">專業服務重點</div>
                        <ul className="space-y-2 text-gray-700">
                          {index === 0 && (
                            <>
                              <li>• 詳細了解物品數量和類型</li>
                              <li>• 確認新舊地址樓層和電梯</li>
                              <li>• 提供透明合理的報價</li>
                            </>
                          )}
                          {index === 1 && (
                            <>
                              <li>• 提供紙箱和包裝材料</li>
                              <li>• 衣物使用衣物箱保護</li>
                              <li>• 書籍和雜物分類裝箱</li>
                            </>
                          )}
                          {index === 2 && (
                            <>
                              <li>• 床墊使用專用保護套</li>
                              <li>• 書桌衣櫃包裝防刮傷</li>
                              <li>• 易碎品特別標記處理</li>
                            </>
                          )}
                          {index === 3 && (
                            <>
                              <li>• 小型搬運車經濟實惠</li>
                              <li>• 2位師傅高效搬運</li>
                              <li>• 物品有序裝載固定</li>
                            </>
                          )}
                          {index === 4 && (
                            <>
                              <li>• 按客戶需求擺放家具</li>
                              <li>• 協助組裝簡易家具</li>
                              <li>• 建議最佳空間配置</li>
                            </>
                          )}
                          {index === 5 && (
                            <>
                              <li>• 回收所有包裝材料</li>
                              <li>• 檢查物品完整無損</li>
                              <li>• 確認客戶滿意度</li>
                            </>
                          )}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 套房搬遷實拍 */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 bg-cyan-100 text-cyan-800 px-4 py-2 rounded-full text-sm font-semibold mb-4">
              <i className="ri-camera-line"></i>
              <span>真實記錄</span>
            </div>
            <h2 className="text-4xl font-bold text-gray-900 mb-4">套房搬遷實拍照片</h2>
            <p className="text-xl text-gray-600">小空間搬遷，同樣專業用心</p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            <div className="group relative overflow-hidden rounded-2xl shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Clothes%20being%20neatly%20folded%20and%20packed%20into%20wardrobe%20boxes%20in%20small%20Taiwan%20studio%20apartment%2C%20organized%20clothing%20packing%20for%20student%20move&width=400&height=400&seq=case3-real-1&orientation=squarish"
                alt="衣物整理打包"
                className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <p className="text-white font-semibold">衣物整理打包</p>
                  <p className="text-white/80 text-sm">衣物箱保護不起皺</p>
                </div>
              </div>
            </div>

            <div className="group relative overflow-hidden rounded-2xl shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Books%20and%20study%20materials%20being%20packed%20into%20small%20boxes%20in%20Taiwan%20student%20room%2C%20organized%20academic%20materials%20packing&width=400&height=400&seq=case3-real-2&orientation=squarish"
                alt="書籍分類裝箱"
                className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <p className="text-white font-semibold">書籍分類裝箱</p>
                  <p className="text-white/80 text-sm">小箱裝書方便搬運</p>
                </div>
              </div>
            </div>

            <div className="group relative overflow-hidden rounded-2xl shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Single%20bed%20mattress%20being%20wrapped%20with%20protective%20plastic%20cover%20in%20Taiwan%20rental%20apartment%2C%20mattress%20protection%20for%20moving&width=400&height=400&seq=case3-real-3&orientation=squarish"
                alt="床墊保護包裝"
                className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <p className="text-white font-semibold">床墊保護包裝</p>
                  <p className="text-white/80 text-sm">專用套袋乾淨衛生</p>
                </div>
              </div>
            </div>

            <div className="group relative overflow-hidden rounded-2xl shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Small%20desk%20and%20chair%20being%20wrapped%20with%20moving%20blankets%20in%20compact%20Taiwan%20studio%2C%20furniture%20protection%20for%20rental%20move&width=400&height=400&seq=case3-real-4&orientation=squarish"
                alt="書桌椅包裝"
                className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <p className="text-white font-semibold">書桌椅包裝</p>
                  <p className="text-white/80 text-sm">保護墊防止刮傷</p>
                </div>
              </div>
            </div>

            <div className="group relative overflow-hidden rounded-2xl shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Two%20movers%20carrying%20boxes%20down%20apartment%20staircase%20in%20Taiwan%20residential%20building%2C%20efficient%20small%20move%20teamwork&width=400&height=400&seq=case3-real-5&orientation=squarish"
                alt="樓梯搬運"
                className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <p className="text-white font-semibold">樓梯搬運</p>
                  <p className="text-white/80 text-sm">兩人協作安全高效</p>
                </div>
              </div>
            </div>

            <div className="group relative overflow-hidden rounded-2xl shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Small%20moving%20van%20with%20organized%20boxes%20and%20furniture%20for%20studio%20apartment%20move%20in%20Taiwan%20neighborhood%2C%20compact%20vehicle%20efficient%20loading&width=400&height=400&seq=case3-real-6&orientation=squarish"
                alt="小型搬運車"
                className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <p className="text-white font-semibold">小型搬運車</p>
                  <p className="text-white/80 text-sm">經濟實惠剛剛好</p>
                </div>
              </div>
            </div>

            <div className="group relative overflow-hidden rounded-2xl shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Mover%20arranging%20furniture%20in%20new%20Taiwan%20studio%20apartment%2C%20bed%20and%20desk%20placement%20in%20compact%20living%20space&width=400&height=400&seq=case3-real-7&orientation=squarish"
                alt="新居家具定位"
                className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <p className="text-white font-semibold">新居家具定位</p>
                  <p className="text-white/80 text-sm">按需求擺放到位</p>
                </div>
              </div>
            </div>

            <div className="group relative overflow-hidden rounded-2xl shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20organized%20studio%20apartment%20after%20successful%20move%20in%20Taiwan%2C%20tidy%20compact%20living%20space%20ready%20for%20new%20tenant&width=400&height=400&seq=case3-real-8&orientation=squarish"
                alt="搬遷完成"
                className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <p className="text-white font-semibold">搬遷完成</p>
                  <p className="text-white/80 text-sm">整潔舒適新空間</p>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-12 grid md:grid-cols-4 gap-6">
            <div className="bg-gradient-to-br from-cyan-50 to-teal-50 rounded-2xl p-6 text-center">
              <div className="w-14 h-14 bg-cyan-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-money-dollar-circle-line text-white text-2xl"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">經濟實惠</h3>
              <p className="text-gray-600 text-sm">學生專屬優惠價格</p>
            </div>
            <div className="bg-gradient-to-br from-teal-50 to-cyan-50 rounded-2xl p-6 text-center">
              <div className="w-14 h-14 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-timer-line text-white text-2xl"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">3 小時完成</h3>
              <p className="text-gray-600 text-sm">快速高效不耽誤時間</p>
            </div>
            <div className="bg-gradient-to-br from-cyan-50 to-teal-50 rounded-2xl p-6 text-center">
              <div className="w-14 h-14 bg-cyan-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-box-3-line text-white text-2xl"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">免費紙箱</h3>
              <p className="text-gray-600 text-sm">提供包裝材料省成本</p>
            </div>
            <div className="bg-gradient-to-br from-teal-50 to-cyan-50 rounded-2xl p-6 text-center">
              <div className="w-14 h-14 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-heart-line text-white text-2xl"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">貼心服務</h3>
              <p className="text-gray-600 text-sm">協助整理讓您更輕鬆</p>
            </div>
          </div>
        </div>
      </section>

      {/* Google 客戶評論照片 */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 bg-yellow-100 text-yellow-800 px-4 py-2 rounded-full text-sm font-semibold mb-4">
              <i className="ri-google-fill"></i>
              <span>Google 評論</span>
            </div>
            <h2 className="text-4xl font-bold text-gray-900 mb-4">學生族群分享的真實照片</h2>
            <p className="text-xl text-gray-600">來自 Google 地圖評論的套房搬遷紀錄</p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mb-8">
            <div className="group relative overflow-hidden rounded-2xl shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Student%20customer%20photo%20of%20small%20studio%20apartment%20being%20packed%20efficiently%20in%20Taiwan%20rental%20housing%2C%20real%20Google%20review%20image%20of%20budget%20moving%20service&width=400&height=400&seq=google-review-3-1&orientation=squarish"
                alt="客戶分享 - 套房打包"
                className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <div className="flex items-center gap-1 mb-1">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-white font-semibold text-sm">黃同學分享</p>
                  <p className="text-white/80 text-xs">打包速度很快</p>
                </div>
              </div>
            </div>

            <div className="group relative overflow-hidden rounded-2xl shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Real%20customer%20photo%20showing%20compact%20moving%20van%20for%20studio%20apartment%20relocation%20in%20Taiwan%20neighborhood%2C%20authentic%20budget%20moving%20service%20review&width=400&height=400&seq=google-review-3-2&orientation=squarish"
                alt="客戶分享 - 小型搬運車"
                className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <p className="text-white font-semibold text-sm">李同學分享</p>
                  <p className="text-white/80 text-xs">車子大小剛好</p>
                </div>
              </div>
            </div>

            <div className="group relative overflow-hidden rounded-2xl shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Authentic%20customer%20review%20photo%20of%20student%20belongings%20neatly%20organized%20in%20boxes%20during%20Taiwan%20rental%20move%2C%20real%20young%20tenant%20moving%20documentation&width=400&height=400&seq=google-review-3-3&orientation=squarish"
                alt="客戶分享 - 物品整理"
                className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <p className="text-white font-semibold text-sm">陳同學分享</p>
                  <p className="text-white/80 text-xs">東西整理得很好</p>
                </div>
              </div>
            </div>

            <div className="group relative overflow-hidden rounded-2xl shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Customer%20shared%20photo%20of%20friendly%20movers%20helping%20with%20small%20furniture%20in%20Taiwan%20student%20rental%20apartment%2C%20real%20Google%20review%20showing%20helpful%20service&width=400&height=400&seq=google-review-3-4&orientation=squarish"
                alt="客戶分享 - 親切服務"
                className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <p className="text-white font-semibold text-sm">王同學分享</p>
                  <p className="text-white/80 text-xs">師傅人很好</p>
                </div>
              </div>
            </div>

            <div className="group relative overflow-hidden rounded-2xl shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Real%20photo%20from%20student%20customer%20showing%20bed%20mattress%20being%20carried%20down%20narrow%20staircase%20in%20Taiwan%20old%20apartment%20building%2C%20authentic%20moving%20review&width=400&height=400&seq=google-review-3-5&orientation=squarish"
                alt="客戶分享 - 床墊搬運"
                className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <p className="text-white font-semibold text-sm">張同學分享</p>
                  <p className="text-white/80 text-xs">床墊搬得很穩</p>
                </div>
              </div>
            </div>

            <div className="group relative overflow-hidden rounded-2xl shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Customer%20review%20photo%20showing%20cozy%20new%20studio%20apartment%20after%20successful%20move%20in%20Taiwan%20rental%20housing%2C%20satisfied%20young%20tenant%20documentation&width=400&height=400&seq=google-review-3-6&orientation=squarish"
                alt="客戶分享 - 新居完成"
                className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <p className="text-white font-semibold text-sm">林同學分享</p>
                  <p className="text-white/80 text-xs">新家好舒適</p>
                </div>
              </div>
            </div>

            <div className="group relative overflow-hidden rounded-2xl shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Authentic%20Google%20review%20photo%20of%20free%20moving%20boxes%20provided%20for%20student%20relocation%20in%20Taiwan%2C%20real%20budget-friendly%20moving%20service%20documentation&width=400&height=400&seq=google-review-3-7&orientation=squarish"
                alt="客戶分享 - 免費紙箱"
                className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <p className="text-white font-semibold text-sm">吳同學分享</p>
                  <p className="text-white/80 text-xs">紙箱免費超讚</p>
                </div>
              </div>
            </div>

            <div className="group relative overflow-hidden rounded-2xl shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Real%20customer%20photo%20of%20happy%20student%20giving%20thumbs%20up%20after%20quick%20studio%20apartment%20move%20in%20Taiwan%2C%20authentic%20satisfied%20young%20customer%20review&width=400&height=400&seq=google-review-3-8&orientation=squarish"
                alt="客戶分享 - 滿意推薦"
                className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <p className="text-white font-semibold text-sm">周同學分享</p>
                  <p className="text-white/80 text-xs">大推給同學們</p>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-3xl shadow-xl p-8 mt-8">
            <div className="flex items-center justify-between flex-wrap gap-4">
              <div className="flex items-center gap-4">
                <div className="w-16 h-16 bg-gradient-to-br from-yellow-400 to-orange-400 rounded-full flex items-center justify-center shadow-lg">
                  <i className="ri-google-fill text-white text-3xl"></i>
                </div>
                <div>
                  <div className="text-2xl font-bold text-gray-900">學生族群好評</div>
                  <div className="flex items-center gap-2 mt-1">
                    <div className="flex items-center gap-1">
                      {[...Array(5)].map((_, i) => (
                        <i key={i} className="ri-star-fill text-yellow-400 text-xl"></i>
                      ))}
                    </div>
                    <span className="text-gray-600 font-semibold">5.0 學生首選</span>
                  </div>
                </div>
              </div>
              <a
                href="https://maps.google.com"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-cyan-600 text-white px-6 py-3 rounded-full font-semibold hover:bg-cyan-700 transition-all cursor-pointer whitespace-nowrap"
              >
                <i className="ri-external-link-line"></i>
                <span>查看更多評論</span>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* 套房搬遷優勢 */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">套房搬遷優勢</h2>
            <p className="text-xl text-gray-600">專為小坪數設計的經濟方案</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-gradient-to-br from-cyan-50 to-teal-50 rounded-2xl p-6 text-center transform hover:scale-105 transition-all">
              <div className="w-16 h-16 bg-cyan-600 rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
                <i className="ri-money-dollar-circle-line text-white text-3xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">經濟實惠</h3>
              <p className="text-gray-600 text-sm">小套房專屬優惠價格，學生族群最愛</p>
            </div>

            <div className="bg-gradient-to-br from-teal-50 to-cyan-50 rounded-2xl p-6 text-center transform hover:scale-105 transition-all">
              <div className="w-16 h-16 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
                <i className="ri-timer-line text-white text-3xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">快速完成</h3>
              <p className="text-gray-600 text-sm">3小時內完成搬遷，不耽誤您的時間</p>
            </div>

            <div className="bg-gradient-to-br from-cyan-50 to-teal-50 rounded-2xl p-6 text-center transform hover:scale-105 transition-all">
              <div className="w-16 h-16 bg-cyan-600 rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
                <i className="ri-box-3-line text-white text-3xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">免費紙箱</h3>
              <p className="text-gray-600 text-sm">提供免費紙箱和包裝材料</p>
            </div>

            <div className="bg-gradient-to-br from-teal-50 to-cyan-50 rounded-2xl p-6 text-center transform hover:scale-105 transition-all">
              <div className="w-16 h-16 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
                <i className="ri-service-line text-white text-3xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">貼心服務</h3>
              <p className="text-gray-600 text-sm">協助打包整理，讓搬家更輕鬆</p>
            </div>
          </div>
        </div>
      </section>

      {/* 服務項目 */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">本次提供的服務</h2>
            <p className="text-xl text-gray-600">套房搬遷全套服務</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-2xl transition-all transform hover:-translate-y-2">
              <div className="w-16 h-16 bg-cyan-100 rounded-full flex items-center justify-center mb-4 mx-auto">
                <i className="ri-box-3-line text-cyan-600 text-3xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 text-center mb-3">打包服務</h3>
              <p className="text-gray-600 text-center text-sm">專業打包，物品分類整理</p>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-2xl transition-all transform hover:-translate-y-2">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mb-4 mx-auto">
                <i className="ri-truck-line text-teal-600 text-3xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 text-center mb-3">搬運服務</h3>
              <p className="text-gray-600 text-center text-sm">專業師傅，安全搬運</p>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-2xl transition-all transform hover:-translate-y-2">
              <div className="w-16 h-16 bg-cyan-100 rounded-full flex items-center justify-center mb-4 mx-auto">
                <i className="ri-home-gear-line text-cyan-600 text-3xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 text-center mb-3">定位服務</h3>
              <p className="text-gray-600 text-center text-sm">按需求擺放家具物品</p>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-2xl transition-all transform hover:-translate-y-2">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mb-4 mx-auto">
                <i className="ri-recycle-line text-teal-600 text-3xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 text-center mb-3">清潔回收</h3>
              <p className="text-gray-600 text-center text-sm">回收包裝材料，清理現場</p>
            </div>
          </div>
        </div>
      </section>

      {/* 更多案例 */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">查看更多成功案例</h2>
            <p className="text-xl text-gray-600">每個案例都是我們的承諾</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-12">
            <Link to="/case-detail-1" className="group">
              <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-all transform hover:-translate-y-2">
                <div className="h-48 overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Modern%20three%20bedroom%20apartment%20interior%20in%20Taiwan%20with%20organized%20furniture%20and%20moving%20boxes%2C%20professional%20moving%20service%2C%20clean%20bright%20family%20living%20space&width=600&height=400&seq=more-case-studio-1&orientation=landscape"
                    alt="家庭搬遷"
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                  />
                </div>
                <div className="p-6">
                  <div className="bg-teal-100 text-teal-800 px-3 py-1 rounded-full text-sm font-semibold inline-block mb-3">
                    家庭搬遷
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-cyan-600 transition-colors">
                    新北板橋 3 房家庭搬遷
                  </h3>
                  <p className="text-gray-600 text-sm">35坪家庭，鋼琴搬運零損傷</p>
                </div>
              </div>
            </Link>

            <Link to="/case-detail-2" className="group">
              <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-all transform hover:-translate-y-2">
                <div className="h-48 overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Modern%20office%20space%20with%20computers%20and%20business%20equipment%20being%20professionally%20moved%20in%20Taipei%20Taiwan%2C%20organized%20commercial%20relocation%20service&width=600&height=400&seq=more-case-studio-2&orientation=landscape"
                    alt="辦公室搬遷"
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                  />
                </div>
                <div className="p-6">
                  <div className="bg-emerald-100 text-emerald-800 px-3 py-1 rounded-full text-sm font-semibold inline-block mb-3">
                    辦公室搬遷
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-cyan-600 transition-colors">
                    台北信義區科技公司搬遷
                  </h3>
                  <p className="text-gray-600 text-sm">50坪科技公司，48小時完成</p>
                </div>
              </div>
            </Link>

            <Link to="/case-detail-4" className="group">
              <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-all transform hover:-translate-y-2">
                <div className="h-48 overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Long%20distance%20moving%20truck%20on%20Taiwan%20highway%20with%20professional%20logistics%2C%20cross-city%20relocation%20service%2C%20secure%20cargo%20transport&width=600&height=400&seq=more-case-studio-3&orientation=landscape"
                    alt="跨縣市搬家"
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                  />
                </div>
                <div className="p-6">
                  <div className="bg-orange-100 text-orange-800 px-3 py-1 rounded-full text-sm font-semibold inline-block mb-3">
                    長途搬家
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-cyan-600 transition-colors">
                    桃園中壢跨縣市搬家
                  </h3>
                  <p className="text-gray-600 text-sm">30坪家庭，一天完成搬遷</p>
                </div>
              </div>
            </Link>
          </div>

          <div className="text-center">
            <Link
              to="/cases"
              className="inline-flex items-center gap-2 bg-cyan-600 text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-cyan-700 transition-all transform hover:scale-105 cursor-pointer whitespace-nowrap shadow-lg"
            >
              <span>查看所有案例</span>
              <i className="ri-arrow-right-line text-xl"></i>
            </Link>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-gradient-to-br from-cyan-50 via-white to-teal-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="bg-white rounded-3xl shadow-2xl p-12">
            <div className="inline-flex items-center gap-2 bg-cyan-100 text-cyan-800 px-4 py-2 rounded-full text-sm font-semibold mb-6">
              <i className="ri-gift-line"></i>
              <span>學生優惠方案</span>
            </div>
            <h2 className="text-4xl font-bold text-gray-900 mb-4">套房搬遷找建鈞</h2>
            <p className="text-xl text-gray-600 mb-8">
              經濟實惠、快速專業，學生族群首選
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/quote"
                className="bg-cyan-600 text-white px-10 py-4 rounded-full text-lg font-semibold hover:bg-cyan-700 transition-all transform hover:scale-105 cursor-pointer whitespace-nowrap shadow-lg flex items-center justify-center gap-2"
              >
                <i className="ri-calculator-line text-xl"></i>
                <span>線上免費估價</span>
              </Link>

              <a
                href="tel:0978900081"
                className="bg-white border-2 border-cyan-600 text-cyan-600 px-10 py-4 rounded-full text-lg font-semibold hover:bg-cyan-50 transition-all transform hover:scale-105 cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
              >
                <i className="ri-phone-line text-xl"></i>
                <span>0978-900-081</span>
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
